import { UseQueryOptions, useQuery } from "react-query";
import { Audience } from "@arelia-types/streaming";
import { http } from "./http";
import { ChartData, FirstRecord, Follower, ServiceArtistModel } from "../types";
import { Song } from "@arelia-types/song";
import { TopCountriesPeriod } from "../widgets/countries/models";
import { TopSongsPeriod } from "../widgets/songs/models";

export function useChartStreams(period: string, ops?: UseQueryOptions<ChartData[]>) {
  return useQuery<ChartData[]>({
    queryKey: ["streams", period],
    queryFn: () => http(`/api/stream/chart-streams?interval=${period}`),
    ...ops
  });
}

export function useChartListeners(period: string, ops?: UseQueryOptions<ChartData[]>) {
  return useQuery<ChartData[]>({
    queryKey: ["listeners", period],
    queryFn: () => http(`/api/stream/chart-listeners?interval=${period}`),
    ...ops
  });
}

export function useAudience(ops?: UseQueryOptions<Audience[]>) {
  return useQuery<Audience[]>({
    queryKey: ["audience"],
    queryFn: () => http("/api/stream/audience"),
    ...ops
  });
}


export function useTopCountries(period: TopCountriesPeriod, ops?: UseQueryOptions<Follower[]>) {
  return useQuery<Follower[]>({
    queryKey: ["audience-top-countries", period],
    queryFn: () => http(`/api/stream/top-countries?period=${period}`),
    ...ops
  });
}

type TopSongs = ServiceArtistModel & {
  songs: Song[];
};

export function useTopSongs(period: TopSongsPeriod, ops?: UseQueryOptions<TopSongs[]>) {
  return useQuery<TopSongs[]>({
    queryKey: ["top-songs", period],
    queryFn: () => http(`/api/stream/top-songs?period=${period}`),
    ...ops
  });
}

export function useFirstRecords(ops?: UseQueryOptions<FirstRecord[]>) {
  return useQuery<FirstRecord[]>({
    queryKey: ["first-record"],
    queryFn: () => http(`/api/stream/first-record`),
    ...ops
  });
}
